/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { PENDING, FULFILLED, REJECTED } from 'mobx-utils';
import PropTypes from 'util/PropTypes';
import classnames from 'classnames';
import NaturalLanguageTextModel from './NaturalLanguageTextModel';
import { ProgressIndicator, SVGIcon } from 'ca-ui-toolkit';
import Empty from 'components/empty/Empty';
import StringResources from 'nls/StringResources';
import UnescapedString from 'util/UnescapedString';
import detailsError128 from '@ba-ui-toolkit/ba-graphics/dist/illustrations/details-error_128.svg';
import details128 from '@ba-ui-toolkit/ba-graphics/dist/illustrations/no-detail_128.svg';

import './NaturalLanguageText.scss';

import { TAB_STATE } from '../canvasTabs/CanvasTabs';

@observer
class NaturalLanguageText extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		const { model, tabState } = this.props;
		let content;

		if (model && model.items && tabState === TAB_STATE.SHOW_DATA) {
			switch(model.items.state) {
				case PENDING:
					content = (
						<div className='explore-nlt__container card-layout-content__side-panel__empty-container'>
							<div className='explore-nlt__loading'>
								<ProgressIndicator size='normal' />
								<div className="explore-nlt__loading__text">{StringResources.get('details_loading')}</div>
							</div>
						</div>
					);
					break;
				case FULFILLED:
					content = this.renderItems();
					break;
				case REJECTED:
					content = (
						<div className='explore-nlt__container card-layout-content__side-panel__empty-container'>
							<Empty
								icon={<SVGIcon iconId={detailsError128.id} size="xxlarge"/>}
								title={StringResources.get('details_error_title')}
								description={StringResources.get('details_error_description')}
							/>
						</div>
					);
					break;
			}
		} else if (tabState !== TAB_STATE.SHOW_DATA) {
			const classes = classnames({
				'explore-nlt__container': true,
				'card-layout-content__side-panel__empty-container': true,
				[`explore-nlt__container_${ tabState }`]: true
			});
			content = (
				<div className={classes}>
					<Empty
						icon={<SVGIcon iconId={details128.id} size="xxlarge"/>}
						title={StringResources.get(`details_${ tabState }_title`)}
						description={StringResources.get(`details_${ tabState }_description`)}
					/>
				</div>
			);
		}

		if (!content || (Array.isArray(content) && !content.length)) {
			// If the content is an array, but it's empty, then still show the empty view.
			content = (
				<div className='explore-nlt__container card-layout-content__side-panel__empty-container'>
					<Empty
						icon={<SVGIcon iconId={details128.id} size="xxlarge"/>}
						title={StringResources.get('details_none_title')}
						description={StringResources.get('details_none_description')}
					/>
				</div>
			);
		}

		return (
			<div className='explore-nlt'>
				{content}
			</div>
		);
	}

	renderItems() {
		return this.props.model.getItems()
			.map((item, index) => this.renderText(item, index));
	}

	renderText(item, key) {
		return (
			<div className="explore-nlt__item" key={key}>
				<UnescapedString><span>{item.label}</span></UnescapedString>
			</div>
		);
	}
}

NaturalLanguageText.propTypes = {
	model: PropTypes.stateTree(NaturalLanguageTextModel),
	tabState: PropTypes.string.isRequired
};

export default NaturalLanguageText;



// WEBPACK FOOTER //
// ./src/js/components/nlt/NaturalLanguageText.js